import { type Module } from 'vuex'

export interface IAdmisionRoutingPayload {
  sessionId?: string
  sessionDispId?: string
  coppId?: number
  ciotId?: number
  ciodIds?: number[]
  diagnosticosIds?: number[]
  cocuTipo?: string
  createdAt: number
}

export interface StateAdmisionRouting {
  routingData: IAdmisionRoutingPayload | null
}

const admisionRouting: Module<StateAdmisionRouting, unknown> = {
  namespaced: true,
  state: (): StateAdmisionRouting => ({ routingData: null }),
  mutations: {
    setRoutingData(state: StateAdmisionRouting, data: IAdmisionRoutingPayload) {
      state.routingData = data
      try {
        const id = data.sessionId || data.sessionDispId
        if (id) {
          sessionStorage.setItem(`admision-${id}`, JSON.stringify(data))
        }
      } catch {
        // ignore storage errors
      }
    },
    clearRoutingData(state: StateAdmisionRouting) {
      if (state.routingData) {
        try {
          const id = state.routingData.sessionId || state.routingData.sessionDispId
          if (id) {
            sessionStorage.removeItem(`admision-${id}`)
          }
        } catch {
          // ignore
        }
      }
      state.routingData = null
    }
  },
  getters: {
    routingData: state => state.routingData
  },
  actions: {
    restoreFromSession({ commit }, sessionId: string) {
      try {
        const raw = sessionStorage.getItem(`admision-${sessionId}`)
        if (!raw) return null
        const payload = JSON.parse(raw) as IAdmisionRoutingPayload
        if ((payload?.sessionId === sessionId || payload?.sessionDispId === sessionId) && payload.createdAt) {
          commit('setRoutingData', payload)
          return payload
        }
      } catch {
        return null
      }
      return null
    }
  }
}

export default admisionRouting
